module.exports = "/_next/static/images/1992281bbe3fc6b91999cb2da957aae1-nubanker-pm@1x.jpg.webp";